import { render, staticRenderFns } from "./PopupOwnersComponent.vue?vue&type=template&id=c181d5ec"
import script from "./PopupOwnersComponent.vue?vue&type=script&lang=js"
export * from "./PopupOwnersComponent.vue?vue&type=script&lang=js"
import style0 from "./PopupOwnersComponent.vue?vue&type=style&index=0&id=c181d5ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports